export const API_BASE_URL = window.__APP_CONFIG__.API_BASE_URL;
